import { EventBuss } from '@/utils/constants'
import { Device } from '@/store/types'
import { Options, Vue } from 'vue-class-component'
import { Action, Getter } from 'vuex-class'

@Options({})
export class ChipMenuMixin extends Vue {
    @Getter('chips') chips!: Array<number>
    @Getter('currentChipIndex') chipIndex!: number
    @Getter('customChipValue') customChipValue!: number
    @Getter('device') device!: Device

    @Action('setCurrentChipIndex') setCurrentChipIndex!: (
        indexPosition: number
    ) => void

    emitter!: Vue['emitter']
    $emit!: Vue['$emit']

    getChipImageWebp(amount: number): string {
        return require(`@/assets/imgs/chips${amount}.webp`)
    }

    getChipImageWebpPng(amount: number): string {
        return require(`@/assets/imgs/chips${amount}.png`)
    }

    getCustomChipValue(): unknown {
        return this.customChipValue <= 0 ? '自定义' : this.customChipValue
    }

    get chipValue(): number {
        if (this.chipIndex === 5) return this.customChipValue || 0
        if (this.chipIndex === -1) return 0
        return this.chips[this.chipIndex] || 0
    }

    chipClicked(index: number): void {
        if (index === this.chipIndex && this.chipIndex !== -1) {
            this.setCurrentChipIndex(-1)
            return
        }

        this.setCurrentChipIndex(index)
    }

    showChipDialog(isTrue: boolean): void {
        if (isTrue) {
            if (this.device.display !== 1) {
                this.$emit('on-show-custom-chip', true)
            } else {
                this.emitter.emit(EventBuss.SHOW_NUMERIC_KEYBOARD, true)
            }
            return
        }

        if (this.customChipValue > 0) {
            if (this.chipIndex === 5) {
                this.setCurrentChipIndex(-1)
            } else {
                this.setCurrentChipIndex(5)
            }
            return
        }

        if (this.device.display !== 1) {
            this.$emit('on-show-custom-chip', true)
        } else {
            this.emitter.emit(EventBuss.SHOW_NUMERIC_KEYBOARD, true)
        }
    }
}
